import { TeamAPI } from '@brg/api';
import { Dispatch } from '@reduxjs/toolkit';
import { OrganizationsActions } from 'shared/reducers/OrganizationsSlice';

type UpdateFtblTeamMembershipParams = {
  dispatch: Dispatch;
  team: any;
  teamId: string;
  accountId: string;
  isJoin: boolean;
};

export const updateFtblTeamMembership = ({
  dispatch,
  team,
  teamId,
  accountId,
  isJoin,
}: UpdateFtblTeamMembershipParams) => {
  if (team) {
    const membersIDs = team.membersIDs || [];
    const updatedMembersIDs = isJoin
      ? [...new Set([...membersIDs, accountId])]
      : membersIDs.filter((id: string) => id !== accountId);

    dispatch(OrganizationsActions.setFullOrganization({
      ...team,
      membersIDs: updatedMembersIDs,
    }));
  }

  return TeamAPI.Get({ idTeam: teamId })
    .then((res) => res.json())
    .then((data) => {
      dispatch(OrganizationsActions.setFullOrganization(data));
    });
};
import { TeamAPI } from '@brg/api';
import { Dispatch } from '@reduxjs/toolkit';
import { OrganizationsActions } from 'shared/reducers/OrganizationsSlice';

type UpdateFtblTeamMembershipParams = {
  dispatch: Dispatch;
  team: any;
  teamId: string;
  accountId: string;
  isJoin: boolean;
};

export const updateFtblTeamMembership = ({
  dispatch,
  team,
  teamId,
  accountId,
  isJoin,
}: UpdateFtblTeamMembershipParams) => {
  if (team) {
    const membersIDs = team.membersIDs || [];
    const updatedMembersIDs = isJoin
      ? [...new Set([...membersIDs, accountId])]
      : membersIDs.filter((id: string) => id !== accountId);

    dispatch(OrganizationsActions.setFullOrganization({
      ...team,
      membersIDs: updatedMembersIDs,
    }));
  }

  return TeamAPI.Get({ idTeam: teamId })
    .then((res) => res.json())
    .then((data) => {
      dispatch(OrganizationsActions.setFullOrganization(data));
    });
};
